import { Button, Box, Typography } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'
import { borderRadius } from '../store/constant'
import { useDrawer } from '@hooks/useDrawer'
import { signOut } from '@lib/firebase'
import mixpanel from 'mixpanel-browser'

function SignOut() {
  const { drawerOpen } = useDrawer()

  async function handleSignOut() {
    try {
      await signOut()
      mixpanel.reset()
      console.log('Signed out successfully')
    } catch (error) {
      console.error('Sign out error', error)
    }
  }

  return (
    <Button
      id='sign-out'
      disableRipple={true}
      aria-label='Sign Out'
      sx={{
        justifyContent: 'flex-start',
        backgroundColor: 'grey.300',
        color: 'grey.700',
        padding: drawerOpen ? '10px 16px' : '0',
        zIndex: 1201,
        borderRadius: `${borderRadius}px`,
        minWidth: 0,
        '&:hover': { color: 'grey.900' },
      }}
      onClick={handleSignOut}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          ...(!drawerOpen && {
            borderRadius: `${borderRadius}px`,
            width: 46,
            height: 46,
          }),
        }}
      >
        <LogoutIcon sx={{ fontSize: 24 }} />
      </Box>

      {drawerOpen && (
        <Typography
          noWrap
          variant='h5'
          sx={{
            ml: 1,
            color: 'inherit',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          Sign Out
        </Typography>
      )}
    </Button>
  )
}

export default SignOut
